import { config } from '@brands/config/config';
import Cookies from 'js-cookie';

export function jwtToken(): string {
  const token = Cookies.get('jwtToken');
  if (token) {
    return token;
  }
  return '';
}

export function cookieOptions(): Cookies.CookieAttributes {
  // SameSite=Lax (not Strict) so the cookie survives cross-site top-level
  // GET navigations back into the app — e.g. JotForm's post-submit redirect
  // to a dentistry.one URL after the OHC intake form. Strict stripped the
  // cookie on that redirect, the redirected tab initialised unauthenticated,
  // and PrivateRoutes' catch path then signed the user out domain-wide
  // (see DO-3955). CSRF surface is unchanged because the backend auths via
  // the `Authorization: Bearer` header — never the cookie — so browser
  // auto-submission of the cookie can't drive an authenticated action.
  const opts: Cookies.CookieAttributes = {
    secure: config.cookie_secure,
    sameSite: 'lax',
  };
  if (config.domain_name && config.domain_name !== 'none') {
    opts.domain = config.domain_name;
  }
  return opts;
}
